import { graphql } from "gatsby"
import React from "react"
import Layout from "../components/Layout"
import * as styles from '../styles/home.module.css'
import Img from 'gatsby-image'

export default function Home({ data }) {
  return (
      <Layout>
          <section>
            <div className={styles.hero}>
              <Img fluid={data.main.childImageSharp.fluid} className={styles.main} />
              <div className={styles.herocopy}>
                <h1 className={styles.heading}>Measuring Movement</h1>
                <h3 className={styles.subtitle}>Pragmatic and privacy-focused markerless motion capture. VisioTherapy helps athletes accurately capture movement to help enhance performance and prevent injuries.</h3>
              </div>
            </div>
            <div className={styles.partners}>
              <Img fluid={data.emovi.childImageSharp.fluid} alt="emovi" className={styles.partner} />
              <Img fluid={data.IRFU.childImageSharp.fluid} className={styles.partner} />
              <Img fluid={data.Trinity.childImageSharp.fluid} className={styles.partner} />
              <Img fluid={data.Leinster.childImageSharp.fluid}className={styles.partner} />
              <Img fluid={data.Swans.childImageSharp.fluid} className={styles.partner} />
              <Img fluid={data.SDM.childImageSharp.fluid} className={styles.partner} />
            </div>
          </section>
            <section className={styles.what}>              
              <h3 className={styles.greenheading}>Pragmatic Motion Capture</h3>
              <div className={styles.rectangle}>
                <div className={styles.point}>
                  <h4>Performance</h4>
                  <Img fluid={data.first.childImageSharp.fluid} alt="first" className={styles.pointCover} />
                </div>
                <div className={styles.point} >
                  <h4>Coaching</h4>
                  <Img fluid={data.second.childImageSharp.fluid} alt="second" className={styles.pointCover} />
                </div>
                <div className={styles.point}>
                  <h4>Recovery</h4>
                  <Img fluid={data.third.childImageSharp.fluid} alt="third" className={styles.pointCover} />
                </div>
              </div>
            </section>
            <section className={styles.whywrap}>
              <h3 className={styles.greenheading}>Why VisioTherapy?</h3>
              <div className={styles.why}>
                <div className={styles.reason}>
                  <h4 className={styles.heading1}>Pragmatic</h4>
                  <p className={styles.description1}>We are focused on making the technology we build with our users  in ming. Our App is simple to use and is easy to set up.</p>
                </div>
                <div className={styles.reason}>
                  <h4 className={styles.heading2}>Privacy</h4>
                  <p className={styles.description2}>Privacy is an important part of our company’s values. We ensure privacy is ensured through the latest technology. </p>
                </div>
                <div className={styles.reason}>
                  <h4 className={styles.heading3}>Accuracy</h4>
                  <p className={styles.description3}>Our computer vision models have been trained using a large dataset.</p>
                </div>
                <div className={styles.reason}>
                  <h4 className={styles.heading4}>Affordable</h4>
                  <p className={styles.description4}>Analysing motion doesn’t have to be expensive. Our product costs much less than a motion capture lab.</p>
                </div>
              </div>
            </section>
      </Layout>
  )
}


export const query = graphql`
  query start {
    main: file(relativePath: {eq: "main.png"}) {
      childImageSharp {
        fluid(maxWidth: 3913, pngQuality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    IRFU: file(relativePath: {eq: "IRFU.png"}) {
      childImageSharp {
        fluid(pngQuality:90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Trinity: file(relativePath: {eq: "Trinity.png"}) {
      childImageSharp {
        fluid(pngQuality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    emovi: file(relativePath: {eq: "emovi.png"}) {
      childImageSharp {
        fluid(pngQuality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Leinster: file(relativePath: {eq: "Leinster.png"}) {
      childImageSharp {
        fluid(pngQuality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Swans: file(relativePath: {eq: "Swans.png"}) {
      childImageSharp {
        fluid(pngQuality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    } 
    SDM: file(relativePath: {eq: "SDM.png"}) {
      childImageSharp {
        fluid(pngQuality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
     
    first: file(relativePath: {eq: "first.png"}) {
      childImageSharp {
        fluid(pngQuality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    } 
    second: file(relativePath: {eq: "second.png"}) {
      childImageSharp {
        fluid(pngQuality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    } 
    third: file(relativePath: {eq: "third.png"}) {
      childImageSharp {
        fluid(pngQuality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
